/**
 * エントリポイント。
 *
 * ここでやることは3つだけ:
 *   1. Service Worker の登録(オフライン動作の前提)
 *   2. 接続監視の開始
 *   3. ルーターの起動
 *
 * どれも通信の完了を待たない。微弱電波で起動が止まるのを避けるため(§4-2)。
 */

import "./app.css";
// 副作用のための読み込み。beforeinstallprompt は読み込み直後に飛んでくるので、
// トップ画面(動的import)を待っていると取りこぼす。
import "./core/install";
import { startRouter, onTitleChange, currentRoute } from "./router";
import { startConnMonitor, onConnChange, getConnState, type ConnState } from "./core/net";
import { reconcileStamps } from "./core/stamps";
import { startSync } from "./core/sync";

const appbar = document.getElementById("appbar") as HTMLElement;
const titleEl = document.getElementById("title") as HTMLElement;
const backEl = document.getElementById("back") as HTMLAnchorElement;
const connEl = document.getElementById("conn") as HTMLElement;
const tabs = document.getElementById("tabs") as HTMLElement;
const view = document.getElementById("view") as HTMLElement;

/** タブを出す画面。トップ(準備画面)や受付・集計では出さない。 */
const TABBED = new Set(["/book", "/scan", "/help"]);

function renderChrome(title: string | null): void {
  const path = currentRoute();
  appbar.hidden = title === null;
  titleEl.textContent = title ?? "";
  backEl.hidden = TABBED.has(path);

  tabs.hidden = !TABBED.has(path);
  for (const a of tabs.querySelectorAll<HTMLAnchorElement>("a[data-tab]")) {
    a.classList.toggle("active", a.dataset.tab === path);
    if (a.dataset.tab === path) a.setAttribute("aria-current", "page");
    else a.removeAttribute("aria-current");
  }

  // 画面遷移のたびにフォーカスを移す(スクリーンリーダー対応)
  view.focus({ preventScroll: true });
  view.scrollTo(0, 0);
}

const CONN_LABEL: Record<ConnState, string> = {
  online: "オンライン",
  offline: "オフライン",
  checking: "確認中",
};

function renderConn(state: ConnState): void {
  connEl.dataset.state = state;
  connEl.textContent = CONN_LABEL[state];
}

onTitleChange(renderChrome);
onConnChange(renderConn);
renderConn(getConnState());

startConnMonitor();
startRouter(view);

// 位置情報の確認中にアプリが落ちて、同期キューに積まれなかったスタンプを回収する。
// 起動のクリティカルパスに乗せない。
void reconcileStamps().then((n) => {
  if (n > 0) console.info(`[stamps] 未同期のスタンプ ${n}件をキューに積みました`);
});

startSync();

// Service Worker の登録は最後。失敗してもアプリは(オンラインなら)動く。
if ("serviceWorker" in navigator) {
  addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err: unknown) => {
      console.warn("[sw] 登録に失敗しました。オフラインでは動作しません。", err);
    });
  });
}
